import { SupplierCategory } from 'src/app/models/supplier-category';
import { createAction, props } from '@ngrx/store';

export const updateSupplierCategories = createAction(
  '[Supply Category] Update',
  props<{ payload: SupplierCategory[] }>(),
);
